<template>
  <div>
    <div class="fb-page" data-href="https://www.facebook.com/A4WORKS/" :data-width="size"
         data-height="" data-small-header="false" data-adapt-container-width="false" data-hide-cover="false"
         data-show-facepile="true">
    </div>

  </div>
</template>

<script>
export default {
  props: ['size'],
  mounted () {
    if (!document.getElementById('facebook-jssdk')) {
      (function (d, s, id) {
        let js
        let fjs = d.getElementsByTagName(s)[0]
        if (d.getElementById(id)) return
        js = d.createElement(s)
        js.id = id
        js.src = 'https://connect.facebook.net/ja_JP/sdk.js#xfbml=1&version=v3.2'
        fjs.parentNode.insertBefore(js, fjs)
      }(document, 'script', 'facebook-jssdk'))
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/common/Facebook.vue